import { CircularProgress, Skeleton } from "@mui/material";
import { neutral } from "../../../constants/colorConstants";

const DashboardSkeleton = ({ type }: any) => {
  const commonSkeletonProps = {
    variant: "text",
    sx: { bgcolor: neutral[200] },
  };
  const progressLength = Array.from({ length: 3 }, (element, index) => index);
  return (
    <>
      {type === "card" && (
        <div className="pw-dashboard-total flex flex-row gap-10 justify-between">
          <div className="flex flex-col gap-4 pw-total-emission text-xs text-neutral-400 font-bold">
            <Skeleton
              variant="text"
              width="20rem"
              sx={{ bgcolor: neutral[200] }}
            />
            <Skeleton
              variant="text"
              width="10rem"
              sx={{ bgcolor: neutral[200] }}
            />
          </div>
        </div>
      )}
      {type === "graph" && (
        <div className="pw-dashboard-scope-top flex flex-col gap-3">
          <Skeleton
            variant="text"
            width="20rem"
            height="1rem"
            sx={{ bgcolor: neutral[200] }}
          />
          <Skeleton
            variant="text"
            width="10rem"
            height="1rem"
            sx={{ bgcolor: neutral[200] }}
          />
          <Skeleton
            variant="rounded"
            height="16rem"
            sx={{ bgcolor: neutral[200] }}
          />
        </div>
      )}
      {type === "progress bar" && (
        <>
          <div className="pw-dashboard-scope-top flex flex-col gap-1">
            <Skeleton
              variant="text"
              width="20rem"
              height="1rem"
              sx={{ bgcolor: neutral[200] }}
            />
            <Skeleton
              variant="text"
              width="10rem"
              height="1rem"
              sx={{ bgcolor: neutral[200] }}
            />
          </div>
          {progressLength.map((each: any) => (
            <div className="flex mt-2 flex-row items-center gap-10" key={each}>
              <CircularProgress
                variant="determinate"
                sx={{
                  color: (theme) =>
                    theme.palette.grey[
                      theme.palette.mode === "light" ? 200 : 800
                    ],
                }}
                size={50}
                thickness={6}
                value={100}
              />
              <div className="flex flex-col gap-1">
                <Skeleton
                  variant="text"
                  width="10rem"
                  height="1rem"
                  sx={{ bgcolor: neutral[200] }}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </>
  );
};

export default DashboardSkeleton;
